module.exports = __webpack_public_path__ + "static/assets/7a058e6feb17c1e566c88439347583b4.svg";